import { observer } from "mobx-react-lite";
import { MergeIcon } from "lucide-react";

import { CoalesceConfiguration } from "@/types/evaluate";
import { BlockProps } from "@/components/PowerBlock/Block";
import { withBlockStore } from "@/components/PowerBlock/Block/block-store";
import { createEmptySources } from "@/components/PowerBlock/Block/hooks";
import { useIsReadonly } from "@/components/PowerBlock/Block/readonly-context";
import SectionGroup from "@/components/PowerBlock/Block/SectionGroup";
import { ArraySourceSelector } from "@/components/PowerBlock/Block/SourceSelectors";
import ValidatedField from "@/components/PowerBlock/Block/ValidatedField";
import { arrayMinLength } from "@/components/PowerBlock/Block/validation/rules";
import { createBlockSchema } from "@/components/PowerBlock/Block/validation/schemaBuilder";

const validationSchema = createBlockSchema<CoalesceConfiguration>()
  .requireName()
  .addRule(
    arrayMinLength(
      "configuration.sources",
      2,
      "At least 2 sources are required for coalesce operation",
    ),
  )
  .build();

const CoalesceBlockCore = observer(
  ({
    sources: availableSources = createEmptySources(),
  }: Omit<BlockProps<CoalesceConfiguration>, "DefaultFields">) => {
    const isReadonly = useIsReadonly();

    return (
      <SectionGroup
        title="Data Sources"
        description="Select sources to coalesce - returns the first non-null value"
        icon={<MergeIcon className="h-4 w-4" />}
      >
        <ValidatedField path="configuration.sources" variant="sources" showValidationIcons={false}>
          <ArraySourceSelector sources={availableSources} min={2} disabled={isReadonly} />
        </ValidatedField>
      </SectionGroup>
    );
  },
);

export default withBlockStore<CoalesceConfiguration>(CoalesceBlockCore, {
  validationSchema,
});
